// extracted by mini-css-extract-plugin
module.exports = {"title":"CheckoutTitle_title__3Xbrc"};